import React from 'react'
import { isDefined } from '@/utils/isDefined'
import Resx from '@/components/Resx'

const ProcessState = ({ processState }) => {
  if (isDefined(processState)) {
    if (processState > 0) { return <span className='ml-1 status status--warning'><Resx name='Common:Processing' /></span> }
  }
  return null
}

export {
  ProcessState
}



// WEBPACK FOOTER //
// ./src/components/reporting/processState.js